var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeakRelation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 140,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    id: "svg_2",
    height: 2,
    width: 1,
    y: 19,
    x: 1055,
    stroke: "#000",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    fill: "#ffffff",
    d: "m2.86238,70l98.13761,-61.93079l98.13761,61.93079l-98.13761,61.93079l-98.13761,-61.93079z",
    id: "svg_11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    fill: "#ffffff",
    d: "m11.82786,69.99979l89.17214,-55.9998l89.17214,55.9998l-89.17214,55.9998l-89.17214,-55.9998z",
    id: "svg_15"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Noto Sans JP",
    fontSize: 24,
    strokeWidth: 0,
    id: "svg_6",
    y: 77.93098,
    x: 28.82423,
    stroke: "#000",
    fill: "#000000",
    fontWeight: "normal",
    fontStyle: "normal"
  }, "Weak Relation"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeakRelation);
export default __webpack_public_path__ + "static/media/WeakRelation.748923d7d4c8f685133d67b0ed047f02.svg";
export { ForwardRef as ReactComponent };